/* Sticky buy bar (snippets/ts-sticky-buy.liquid).

   Shows once the main add-to-cart button is above the viewport, hides while
   the footer is on screen. Mirrors the buy box instead of owning state:
   - price: copied from the visible price in #price-<section>, which the theme
     re-renders on every variant change;
   - pack: the checked option of the theme's (hidden) variant picker;
   - button: clicks the main add button, and copies its label and disabled
     state (e.g. "Ausverkauft" for a sold-out pack).
   Publishes its height as --sticky-atc-bar-height, which the theme's
   back-to-top button already offsets itself by. */
(function () {
  function visiblePrice(box) {
    if (!box) return '';
    var items = box.querySelectorAll('.f-price-item--sale, .f-price-item--regular');
    for (var i = 0; i < items.length; i++) {
      var el = items[i];
      if (el.offsetParent !== null && el.closest('.f-price__sale, .f-price--on-sale .f-price__sale')) return el.textContent.trim();
    }
    for (var j = 0; j < items.length; j++) {
      if (items[j].offsetParent !== null && items[j].textContent.trim()) return items[j].textContent.trim();
    }
    return '';
  }

  function init(bar) {
    var sectionId = bar.getAttribute('data-section');
    var scope = document.getElementById('MainProduct-' + sectionId) || document;
    var main = scope.querySelector('.product__info-wrapper form[action*="/cart/add"] button[name="add"]') ||
      scope.querySelector('form[action*="/cart/add"] button[name="add"]');
    if (!main) return;

    var btn = bar.querySelector('[data-ts-sticky-add]');
    var priceEl = bar.querySelector('[data-ts-sticky-price]');
    var packEl = bar.querySelector('[data-ts-sticky-pack]');
    var priceBox = document.getElementById('price-' + sectionId);
    var root = document.documentElement;
    var mainOut = false, footerIn = false, shown = false;

    function sync() {
      var p = visiblePrice(priceBox);
      if (p) priceEl.textContent = p;
      var picker = scope.querySelector('variant-selects');
      var checked = picker && (picker.querySelector('input[type="radio"]:checked') || picker.querySelector('select'));
      var pack = checked && checked.value && checked.value !== 'Default Title' ? checked.value : '';
      packEl.textContent = pack;
      packEl.hidden = !pack;
      var label = main.querySelector('span') ? main.querySelector('span').textContent.trim() : main.textContent.trim();
      if (label) btn.textContent = label;
      btn.disabled = main.disabled || main.getAttribute('aria-disabled') === 'true';
    }

    function render() {
      var show = mainOut && !footerIn;
      if (show === shown) return;
      shown = show;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      btn.tabIndex = show ? 0 : -1;
      document.body.classList.toggle('ts-sticky-buy-on', show);
      root.style.setProperty('--sticky-atc-bar-height', show ? bar.offsetHeight + 'px' : '0px');
      if (show) sync();
    }

    new IntersectionObserver(function (entries) {
      var e = entries[0];
      // Only count it as "out" once it has left through the top: above the fold
      // on first load the bar must stay hidden.
      mainOut = !e.isIntersecting && e.boundingClientRect.top < 0;
      render();
    }).observe(main);

    var footer = document.querySelector('.shopify-section-group-footer-group, footer');
    if (footer) {
      new IntersectionObserver(function (entries) {
        footerIn = entries[0].isIntersecting;
        render();
      }).observe(footer);
    }

    if (priceBox && 'MutationObserver' in window) {
      new MutationObserver(sync).observe(priceBox, { childList: true, subtree: true, characterData: true });
    }
    new MutationObserver(sync).observe(main, { attributes: true, childList: true, subtree: true, characterData: true });
    scope.addEventListener('change', function () { setTimeout(sync, 50); });

    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      main.click();
    });
    sync();
  }

  function boot() {
    document.querySelectorAll('[data-ts-sticky-buy]').forEach(function (bar) {
      if (bar.dataset.tsReady) return;
      bar.dataset.tsReady = '1';
      init(bar);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
